// Firebase Analytics 이벤트 추적 유틸리티

declare global {
    interface Window {
        gtag: (...args: any[]) => void;
    }
}

// 페이지뷰 이벤트
export const trackPageView = (page_title: string, page_location?: string) => {
    if (typeof window !== 'undefined' && window.gtag) {
        window.gtag('event', 'page_view', {
            page_title,
            page_location: page_location || window.location.href,
        });
    }
};

// 앱 다운로드 버튼 클릭 이벤트
export const trackAppDownload = (platform: 'google_play' | 'app_store') => {
    if (typeof window !== 'undefined' && window.gtag) {
        window.gtag('event', 'app_download_click', {
            platform,
            app_name: 'tobe_ai',
        });
    }
};

// 멘토 카드 클릭 이벤트
export const trackMentorClick = (mentorName: string) => {
    if (typeof window !== 'undefined' && window.gtag) {
        window.gtag('event', 'mentor_click', {
            mentor_name: mentorName,
        });
    }
};

// 데모 카드 클릭 이벤트
export const trackDemoClick = (demoType: string) => {
    if (typeof window !== 'undefined' && window.gtag) {
        window.gtag('event', 'demo_click', {
            demo_type: demoType,
        });
    }
};

// 푸터 링크 클릭 이벤트
export const trackFooterLinkClick = (linkType: string) => {
    if (typeof window !== 'undefined' && window.gtag) {
        window.gtag('event', 'footer_link_click', {
            link_type: linkType,
        });
    }
};

// 스크롤 이벤트 (섹션별)
export const trackSectionView = (sectionName: string) => {
    if (typeof window !== 'undefined' && window.gtag) {
        window.gtag('event', 'section_view', {
            section_name: sectionName,
        });
    }
}; 